<div id="container" [chart]="chart">
</div> 

<script src = "node_modules/highcharts-broken-axis/index.js"></script>
<script src="http://code.highcharts.com/maps/modules/exporting.js"></script>
<script src="http://code.highcharts.com/maps/modules/boost.js"></script>
